import Vue from 'vue'
import Vuex from 'vuex'
import {
  getStbConfigProductVersionList
} from "./lib";

Vue.use(Vuex)

const protectedTagList = getStbConfigProductVersionList();

export default new Vuex.Store({
  state: {
    token: (function (raw) {
      if (raw) {
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${raw}`;
      }
      return raw;
    })(localStorage.getItem('token')),
    user: (function (raw) {
      try {
        return JSON.parse(raw);
      } catch (err) {
        return {};
      }
    })(localStorage.getItem('user')),
    status: '',
    themeDarkEnabled: (function (raw) {
      try {
        return JSON.parse(raw || true);
      } catch (err) {
        return true;
      }
    })(localStorage.getItem('themeDarkEnabled')),
    configTagList: [],
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    userId: state => {
      if (state.user && state.user.userId) {
        return state.user.userId;
      } else {
        return ""
      }
    },
    userDisplayName: state => {
      if (state.user && state.user.displayName) {
        return state.user.displayName;
      } if (state.user && state.user.userId) {
        return state.user.userId;
      } else {
        return ""
      }
    },
    userIsAdmin: state => {
      if (state.user && state.user.accessLevel === "Admin") {
        return true;
      } else {
        return false;
      }
    },
    configTagUserList: state => state.configTagList,
    configTagList: state => state.configTagList.concat(protectedTagList).sort(),
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, payload) {
      state.status = 'success';
      state.token = payload.token;
      state.user = payload.user;
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      state.status = '';
      state.token = null;
      state.user = null;
    },
    dark_mode(state, enabled) {
      localStorage.setItem('themeDarkEnabled', JSON.stringify(enabled));
      state.themeDarkEnabled = enabled;
    },
    display_name(state, value) {
      state.user.displayName = value;
      localStorage.setItem('user', JSON.stringify(state.user));
    },
    config_tag_list_reset(state) {
      state.configTagList = [];
    },
    config_tag_add(state, value) {
      switch (typeof value) {
        case "string":
          if (!protectedTagList.includes(value) && !state.configTagList.includes(value)) {
            state.configTagList.push(value);
          }
          break;
        case "object":
          if (value instanceof Array) {
            value.forEach(v => {
              if (!protectedTagList.includes(v) && !state.configTagList.includes(v)) {
                state.configTagList.push(v);
              }
            });
          }
          break;
      }
      state.configTagList.sort();
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        window.axios.post("/auth", {
          username: user.username,
          password: user.password
        })
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem('token', token);
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            window.axios.get("/users/self").then(response => {
              const user = {
                userId: response.data.user_id,
                displayName: response.data.display_name || response.data.user_id
                  .replace(/(\.prestataire)?@.*/, "").split('.').map(w => w[0].toUpperCase() + w.slice(1)).join(' '),
                accessLevel: response.data.access_level,
              };
              localStorage.setItem('user', JSON.stringify(user));
              commit('auth_success', { token: token, user: user });
              resolve();
            }).catch(result => {
              commit('auth_error', result);
              reject(result);
            });
          })
          .catch(result => {
            commit('auth_error', result);
            reject(result);
          });
      })
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout')
        window.axios.delete("/auth");
        delete window.axios.defaults.headers.common['Authorization'];
        resolve();
      })
    }
  },
  modules: {
  }
})
